//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

export class ShowLogo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="channelLogo">
                <img alt="Channel Logo" src={this.props.channelLogo} />
            </div>
        );
    }
}

ShowLogo.propTypes = {
    channelLogo: PropTypes.string
};

export default translate(['translation'])(ShowLogo);




// WEBPACK FOOTER //
// ./src/components/SharedComponents/logo/showLogo.js